import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const TripsIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    className="icon icons8-Map-Pinpoint-Filled"
  >
    <g id="surface1">
      <path d="M 12 2 C 6.484375 2 2 6.484375 2 12 C 2 18.308594 10.847656 29.175781 11.226563 29.636719 L 12 30.574219 L 12.769531 29.636719 C 13.148438 29.179688 22 18.375 22 12 C 22 6.484375 17.515625 2 12 2 Z M 12 9 C 13.65625 9 15 10.34375 15 12 C 15 13.65625 13.65625 15 12 15 C 10.34375 15 9 13.65625 9 12 C 9 10.34375 10.34375 9 12 9 Z M 38 20 C 32.484375 20 28 24.484375 28 30 C 28 36.210938 36.847656 47.167969 37.222656 47.628906 L 37.996094 48.578125 L 38.769531 47.640625 C 39.148438 47.183594 48 36.40625 48 30 C 48 24.484375 43.515625 20 38 20 Z M 38 27 C 39.65625 27 41 28.34375 41 30 C 41 31.65625 39.65625 33 38 33 C 36.34375 33 35 31.65625 35 30 C 35 28.34375 36.34375 27 38 27 Z " />
    </g>
  </IconSvg>
)

export default TripsIcon
